<template>
  <div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label" for="d_file">Agreement KODAK w/h Distributor</label>
          <br>
          <template v-if="dFile">
            <a :href="`/roll_outs/${rollOutId}/agreement_files_rows/${agreementFilesRow.id}/agreement_files/${dFile.id}`" target="_blank">
              <p>
                {{ dFile.original_name}}
                <br>
                ({{ dFile.created_at | datetime }})
              </p>
            </a>
            <button class="btn btn-secondary btn-sm"
              @click.prevent="deleteFile('d_file')"
            >
              Delete Agreement KODAK w/h Distributor <i class="fa fa-trash-alt"></i>
            </button>
          </template>
          <input type="file" name="d_file" id="d_file"
            v-else
            @change="uploadDFile"
          >
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label" for="test_agreement">Latest Approved Business Case</label>
          <br>
          <template v-if="bcFile">
            <a :href="`/roll_outs/${rollOutId}/agreement_files_rows/${agreementFilesRow.id}/agreement_files/${bcFile.id}`" target="_blank">
              <p>
                {{ bcFile.original_name}}
                <br>
                ({{ bcFile.created_at | datetime }})
              </p>
            </a>
            <button class="btn btn-secondary btn-sm"
              @click.prevent="deleteFile('bc_file')"
            >
              Delte Latest Approved Business Case <i class="fa fa-trash-alt"></i>
            </button>
          </template>
          <input type="file" name="test_agreement" id="test_agreement"
            v-else
            @change="uploadBcFile"
          >
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="custom-label" for="test_agreement">Agreement Distributor w/h Key Account</label>
          <br>
          <template v-if="kaFile">
            <a :href="`/roll_outs/${rollOutId}/agreement_files_rows/${agreementFilesRow.id}/agreement_files/${kaFile.id}`" target="_blank">
              <p>
                {{ kaFile.original_name}}
                <br>
                ({{ kaFile.created_at | datetime }})
              </p>
            </a>
            <button class="btn btn-secondary btn-sm"
              @click.prevent="deleteFile('ka_file')"
            >
              Delete Agreement Distributor w/h Key Account <i class="fa fa-trash-alt"></i>
            </button>
          </template>
          <input type="file" name="test_agreement" id="test_agreement"
            v-else
            @change="uploadKaFile"
          >
        </div>
      </div>
      <div class="delete-row" v-if="canDeleteRow">
        <button class="btn btn-secondary btn-sm" @click="deleteRow">
          <i class="fa fa-trash-alt"></i>
        </button>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
  import { datetime } from './../../filters'

  export default {
    props: ['agreementFilesRow', 'rollOutId'],
    data() {
      return {
      }
    },
    filters: {
      datetime,
    },
    methods: {
      uploadSingleFile (type, file) {
        const formData = new FormData
        formData.append('type', type)
        formData.append('file', event.target.files[0])
        const fileUploadUrl = `/roll_outs/${this.rollOutId}/agreement_files_rows/${this.agreementFilesRow.id}/agreement_files`
        return axios.post(fileUploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      },
      uploadDFile (event) {
        this.uploadSingleFile('d_file_id', event.target.files[0]).then(({data}) => {
          this.agreementFilesRow.d_file = data
          window.notification.success('Agreement KODAK w/h Distributor', 'Success!')
        })
      },
      uploadBcFile (event) {
        this.uploadSingleFile('bc_file_id', event.target.files[0]).then(({data}) => {
          this.agreementFilesRow.bc_file = data
          window.notification.success('Latest Approved Business Case', 'Success!')
        })
      },
      uploadKaFile (event) {
        this.uploadSingleFile('ka_file_id', event.target.files[0]).then(({data}) => {
          this.agreementFilesRow.ka_file = data
          window.notification.success('Agreement Distributor w/h Key Account', 'Success!')
        })
      },
      deleteFile (type) {
        if (confirm('Do you really want to delete the file?')) {
          axios.delete(`/roll_outs/${this.rollOutId}/agreement_files_rows/${this.agreementFilesRow.id}/agreement_files/${type}`).then(({data}) => {
            this.agreementFilesRow[type] = null
          })
        }
      },
      deleteRow () {
        if (confirm('Do you really want to delete the row?')) {
         axios.delete(`/roll_outs/${this.rollOutId}/agreement_files_rows/${this.agreementFilesRow.id}`).then(({data}) => this.$emit('rowDeleted', data))
        }
      },
    },
    computed: {
      dFile () {
        return this.agreementFilesRow.d_file
      },
      bcFile() {
        return this.agreementFilesRow.bc_file
      },
      kaFile() {
        return this.agreementFilesRow.ka_file
      },
      canDeleteRow () {
        return ! (this.agreementFilesRow.d_file || this.agreementFilesRow.bc_file || this.agreementFilesRow.ka_file)
      },
    },
  }
</script>

<style type="text/css">
  .delete-row {
    position: absolute;
    right: 10px;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/roll_outs/AgreementFilesRow.vue